// The two NET P&L figures every trade screen shows (27 Oct 2026), the same for Futures, BUY / SELL Options, Iron Condor
// and Box Spread. Both are after entry charges and estimated exit charges, with realised P&L of closed legs / pairs
// included; they differ only in how the OPEN legs are valued:
//   NET P&L at LTP       open legs at their last traded price - the figure every Auto Square-Off profit target compares
//   NET P&L at BID/ASK   open legs closed at the bid (a long is SOLD) / the ask (a short is BOUGHT back); options,
//                        Iron Condor and Box walk the visible depth
export const NET_LTP_LABEL = "Net P&L at LTP";
export const NET_BIDASK_LABEL = "Net P&L at bid/ask";
export const NET_LTP_NOTE = "Actual fills, open legs at LTP, after entry and estimated exit charges, realised P&L included. The Auto Square-Off profit target compares this figure.";
export const NET_BIDASK_NOTE = "Actual fills, open legs closed at the bid (SELL to close) / ask (BUY to close) using the visible depth, after entry and estimated exit charges, realised P&L included. Shown for reference; it does not trigger the target.";

const num = (v) => (v === null || v === undefined || v === "" || Number.isNaN(Number(v)) ? null : Number(v));

/** {ltp, bidask} for the rows that have each figure, summed (both are NET with the same rules, so they add up). */
export function netTotals(rows) {
  const out = { ltp: null, bidask: null, n_ltp: 0, n_bidask: 0 };
  for (const r of rows || []) {
    const a = num(r.net_pnl_ltp), b = num(r.net_pnl_bidask);
    if (a != null) { out.ltp = Math.round(((out.ltp || 0) + a) * 100) / 100; out.n_ltp += 1; }
    if (b != null) { out.bidask = Math.round(((out.bidask || 0) + b) * 100) / 100; out.n_bidask += 1; }
  }
  return out;
}

/** A Futures v25 trade view's two NET figures: live from the view; a completed cycle shows its realised net in both. */
export function futuresNet(t) {
  if (t?.status === "COMPLETE" && t.last_cycle) {
    const r = num(t.last_cycle.realised_pnl), c = num(t.last_cycle.charges);
    const v = r != null && c != null ? Math.round((r - c) * 100) / 100 : null;
    return { ltp: v, bidask: v };
  }
  return { ltp: num(t?.net_pnl_ltp), bidask: num(t?.net_pnl_bidask) };
}
